import { useMemo } from 'react';
import { ActionName } from '../../../constants/Bi';
import { bi } from '../../../services/loggers/bi';
import { extractCommonBiFieldsFromItems } from '../../bi';
import { MediaManagerSDKAnyItem } from '../../media-manager-sdk';
import { useFileType } from './useFileType';
import { ClickOrigin } from './useTrackTrashActions';
import { mediaManagerPanelFileInfoActionsClick } from '@wix/bi-logger-media-data/v2';

export const useTrackInfoPanelFileActions = () => {
  const fileType = useFileType();

  return useMemo(
    () => ({
      trackInfoPanelFileAction: (items: MediaManagerSDKAnyItem | MediaManagerSDKAnyItem[], actionName: ActionName) =>
        bi.logger().report(
          mediaManagerPanelFileInfoActionsClick({
            actionName,
            clickOrigin: ClickOrigin.MoreInfo,
            ...extractCommonBiFieldsFromItems(items, { fileType }),
          }),
        ),
    }),
    [fileType],
  );
};
